import { Text } from '@soteria/design-system-ve';

import { LikeDislikeButtons } from '../../LikeDislikeButtons/LikeDislikeButtons';
import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

interface NonTriggeredPolicyRowProps {
  policy: {
    id: string;
    name: string;
    description?: string;
    communityId: string;
    isEnabled: boolean;
    labels: Array<{
      labelId: string;
      severity: number;
    }>;
  };
  assessment?: {
    policyId: string;
    policyName: string;
    isCorrect: boolean | null;
    comments?: string;
  };
  onAssessmentChange: (assessment: { policyId: string; policyName: string; isCorrect: boolean | null; comments?: string }) => void;
  disabled?: boolean;
}

export function NonTriggeredPolicyRow({ policy, assessment, onAssessmentChange, disabled = false }: NonTriggeredPolicyRowProps) {
  const handleLikeDislikeChange = (value: boolean | null) => {
    onAssessmentChange({
      policyId: policy.id,
      policyName: policy.name,
      isCorrect: value,
      comments: assessment?.comments || '',
    });
  };

  return (
    <div className={spacingStyles.assessmentRowNoBadge}>
      <Text className={styles.policyName}>{policy.name}</Text>
      <LikeDislikeButtons disabled={disabled} name={`policy-${policy.id}`} value={assessment?.isCorrect ?? null} onChange={handleLikeDislikeChange} />
    </div>
  );
}
